import { useCallback } from "react";
import { useFeatures } from "../context/FeatureContext";
import {
    filterChecklistItems,
    filterDashboardLinks,
    isModuleSectionVisible,
    isRouteModuleVisible,
} from "../config/adminNavFeatures";

export function useDashboardFeatures() {
    const { mode, isModuleEnabled, enabledModules } = useFeatures();

    const canShowRoute = useCallback(
        (route) => isRouteModuleVisible(route, isModuleEnabled, mode),
        [isModuleEnabled, mode],
    );

    const canShowModule = useCallback(
        (moduleId) => isModuleSectionVisible(moduleId, isModuleEnabled, mode),
        [isModuleEnabled, mode],
    );

    const filterLinks = useCallback(
        (links) => filterDashboardLinks(links, isModuleEnabled, mode),
        [isModuleEnabled, mode],
    );

    const filterChecklist = useCallback(
        (items) => filterChecklistItems(items, isModuleEnabled, mode),
        [isModuleEnabled, mode],
    );

    return {
        mode,
        enabledModules,
        canShowRoute,
        canShowModule,
        filterLinks,
        filterChecklist,
    };
}
